module.exports = __webpack_public_path__ + "img/chek.7018ec0e.png";